import axios from 'axios'
import Cookie from 'js-cookie'
import { message } from 'antd'

const $axios = axios.create({
    timeout: 60 * 1000,
    baseURL: process.env.REACT_APP_API_URL
})

// 请求拦截
$axios.interceptors.request.use(config => {
    config.headers = {
        ...config.headers,
        token: Cookie.get('token')
    }
    return config
}, error => {
    return Promise.reject(error)
})

// 响应拦截
$axios.interceptors.response.use(function (response) {
    const code = response.data.code
    if (code === 100004) {
        // token过期
        Object.keys(Cookie.get()).forEach((item) => {
            Cookie.remove(item)
        })
        window.location.href = "/";
    } else if (code !== 1 && code !== 200) {
        message.error(response.data.msg)
    }

    return Promise.resolve(response.data)
}, error => {
    return Promise.reject(error)
})

export default $axios
